import { CanonicalService } from '../shared/seo/canonical.service';
import { SeoService } from '../shared/seo/seo.service';
import { ClevertapService } from '../shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {
  show:any;
  metatitle: any = "Tata Motors Terms & Conditions | Legal Information";
  metadesc: any="Enquire, book and buy online Tata Ace, Intra, Yodha Pickup, Winger, Magic, Signa, Prima, Ultra, and entire Truck, Tipper, Bus range with Tata Motors authorized dealers.";

  constructor(private canonicalservice: CanonicalService,private router: Router,
    private cleverService: ClevertapService,private seoservice: SeoService,
     @Inject(PLATFORM_ID) private platformId: Object) { }

  ngOnInit(): void {
    this.seo();

    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Terms and Conditions");
      } catch { }
    }
  this.canonicalservice.createCanonicalURL('');
  }
  showHide(item){
    this.show = item;
  }
  seo() {
    this.seoservice.updateTitle(this.metatitle);
    this.seoservice.updateMetaTag("description", null, this.metadesc);
    this.seoservice.updateMetaTag(null, "og:locale", "en_US");
    this.seoservice.updateMetaTag(null, "og:type", "Website");
    this.seoservice.updateMetaTag(
      null,
      "og:title",
      this.metatitle
    );
    this.seoservice.updateMetaTag(null, "og:description", this.metadesc);
    this.seoservice.updateMetaTag(null, "og:url", environment.baseUrl + this.router.url);
    this.seoservice.updateMetaTag(null, "og:site_name", "Tata OSP");
  }
}
